import React, { } from 'react';
import './CustomModal.scss';

interface CustomCheckBoxProp {
    open: boolean,
    className?: string,
    onClose?: () => void,
}

const CustomModal: React.FunctionComponent<CustomCheckBoxProp> = (props) => {
    return (
        <>
            {props.open &&
                <>
                    <div className="custom-model-overlay nice-scroll"
                    >

                        <div className={"custom-model-content " + (props.className ? props.className : "")}>
                            <div className='custom-model-close'
                                onClick={() => {
                                    if (props.onClose) {
                                        props.onClose();
                                    }
                                }}
                            >
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </div>
                            {props.children}
                        </div>
                    </div></>
            }
        </>
    );
};

export default CustomModal;
